import { FetchState } from "../Models/Client/FetchState"
import { useAppState } from "./useReduxState"
import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { MetricRequest } from "../Models/Client/MetricRequest"
import {
    APIAppMetricModel,
    toMetricRequest
} from "../Models/API/AppMetricModel"
import { Result } from "../Models/Utility/Result"
import { getCustomizeMetrics } from "../Actions/API/AppInstance/AppInstanceCustomizeActions"
import { createSelector } from "reselect"
import { State } from "../Reducers"

const selectVariants = createSelector(
    (state: State, appID: string | undefined) => {
        if (appID === undefined) {
            return undefined
        }

        const entry = state.api.appCustomize[appID]

        return entry === undefined ? undefined : entry.latestMetrics
    },
    (variants: APIAppMetricModel[] | undefined) =>
        variants === undefined
            ? undefined
            : Result.ok(variants.map(toMetricRequest))
)

export function useMetricVariants(appID?: string): FetchState<MetricRequest[]> {
    const dispatch = useDispatch()
    const fetchState = useAppState(state => selectVariants(state, appID))

    useEffect(() => {
        if (appID === undefined || fetchState !== undefined) {
            return
        }

        dispatch(getCustomizeMetrics(appID))
    }, [appID, fetchState, dispatch])

    return fetchState
}
